import "./_common";
import { GlobalComponents, GlobalStores } from "../react_isomorphic/global";
import { HeaderComponents, HeaderStores } from "../react_isomorphic/site_header";
import { UserShowComponents, UserShowStores } from "../react_isomorphic/mobile/user_show";
import { merge } from "lodash";

window.ReactComponents = merge({}, GlobalComponents, UserShowComponents, HeaderComponents);
window.ReactStores = merge({}, GlobalStores, UserShowStores, HeaderStores);
